import React, { useState, useEffect, useMemo } from "react";
import {
  Typography,
  Grid2 as Grid,
  Link,
} from "@mui/material";
import { connect } from "react-redux";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

import { useNavigate, useParams } from "react-router-dom";
import { Loading } from "../../components/loading/Loading";
import ClientCard from "../../components/cards/ClientCard";
import InfoCard from "../../components/cards/InfoCard";
import TableDetailInvest from "../../components/admin/TableDetailInvest";
import { getUser } from "../../actions/users";
import { isEmpty } from "../../components/common/helpers";

const ClientDetail = ({
  getUser,
  user,
  loading: loadingUser
}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (id) {
      getUser(id);
    }
  }, [id, getUser]);

  useEffect(() => {
    if (user && !loadingUser) {
      setLoading(false);
    }
  }, [user, loadingUser]);

  const { clientDetail, stats, investments } = useMemo(() => {
    if (!user) return {
      clientDetail: {},
      stats: { totalInv: 0, totalCont: 0 },
      investments: []
    };

    const inversiones = user.datos_empresas?.[0]?.inversiones || [];
    let totalInvSum = 0;
    let totalContSum = 0;

    inversiones.forEach(inv => {
      const type = inv.tipo ? inv.tipo.toLowerCase() : '';

      if (type === 'servicio') {
        if (inv.status === 1) {
          totalContSum += inv.monto;
        }
      } else if (type === 'inversión' || type === 'inversion') {
        totalInvSum += inv.monto;
      } else {
        // Fallback for legacy data without 'tipo'
        if (!isEmpty(inv.servicio) && inv.servicio !== 'null') {
          if (inv.status === 1) totalContSum += inv.monto;
        } else {
          totalInvSum += inv.monto;
        }
      }
    });

    return {
      clientDetail: {
        _id: user._id,
        name: user.datos_empresas?.[0]?.razon_social,
        email: user.datos_empresas?.[0]?.email,
        rfc: user.datos_empresas?.[0]?.rfc || "N/A",
        status: "aprobado" // Assuming default or derived from somewhere
      },
      stats: {
        totalInv: totalInvSum,
        totalCont: totalContSum
      },
      investments: inversiones
    };
  }, [user]);

  const statistics = [
    { title: "Total invertido", value: `$${stats.totalInv.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, info: "Suma de todas las inversiones" },
    { title: "Total contratado", value: `$${stats.totalCont.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, info: "Suma de contratos" },
  ];

  if (loading || loadingUser) {
    return <Loading />
  }

  return (
    <Grid container mt={{ xs: 10, md: 12 }} spacing={2}>
      <Grid size={12}>
        <Typography component="p" mt={3}>
          <Link
            href="/admin/inversionistas"
            underline="none"
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <ArrowBackIosIcon sx={{ fontSize: "14px" }} />
            Volver a la lista
          </Link>
        </Typography>
        <Typography mt={3} variant="h5" color="primary" sx={{ fontWeight: "bold" }}>
          Detalles del cliente
        </Typography>
        <Typography
          variant="body2"
          color="#737791"
          sx={{ marginBottom: 1 }}
        >
          Información completa y gestión
        </Typography>
      </Grid>
      <Grid size={12}>
        <ClientCard
          userClient={clientDetail}

          handleDelete={() => console.log("ID", clientDetail._id)}
          handleAccept={() => console.log("ID", clientDetail._id)}
        />
      </Grid>
      <Grid size={12}>
        <Grid container spacing={3}>
          {statistics.map((statistic, index) => (
            <Grid
              key={`statistic${index}`}
              size={{ xs: 12, md: 6, }}
            >
              <InfoCard item={statistic} handleLink={() => { }} />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid size={12} mt={3}>
        <Typography variant="h6" color="primary">
          Lista de inversiones
        </Typography>
        <Typography
          variant="body2"
          color="#737791"
          sx={{ marginBottom: 1 }}
        >
          Historial de movimientos
        </Typography>
      </Grid>
      <TableDetailInvest investments={investments} />
    </Grid>
  );
}

const mapStateToProps = state => ({
  user: state.users.user,
  loading: state.users.loading,
});

export default connect(mapStateToProps, {
  getUser
})(ClientDetail);
